import axios from "axios";

export default function UserNetworkListService(userId) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/user/" + userId + "/networks",
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
